export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_REQUEST_SUCCESS = "REGISTER_USER_REQUEST_SUCCESS";
export const REGISTER_USER_REQUEST_ERROR = "REGISTER_USER_REQUEST_ERROR";
export const RESET_USER_MANAGEMENT = "RESET_USER_MANAGEMENT";
